import { QrcodeOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useState } from 'react'

import { QRModal } from './QRModal'

export const QRButton = () => {
  const [isOpen, setIsOpen] = useState(false)

  const onToggle = () => setIsOpen((prev) => !prev)

  return (
    <>
      <Button icon={<QrcodeOutlined />} onClick={onToggle} />

      {isOpen && <QRModal onCancel={onToggle} />}
    </>
  )
}
